// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getStaffPositionById } from 'app/constants/enums/StaffPosition/main';

/* eslint-disable max-len */
export const CONTENT_POSITION = getStaffPositionById('content');
export const CORPORATE_SUPPORT_POSITION = getStaffPositionById('corporateSupport');
export const CUSTOMER_SUPPORT_POSITION = getStaffPositionById('customerSupport');
export const DEVELOPER_POSITION = getStaffPositionById('developer');
export const DICTIONARY_CONTENT_POSITION = getStaffPositionById('dictionaryContent');
export const MARKETING_POSITION = getStaffPositionById('marketing');
export const SENIOR_CONTENT_POSITION = getStaffPositionById('seniorContent');
export const SENIOR_CORPORATE_SUPPORT_POSITION = getStaffPositionById('seniorCorporateSupport');
export const SENIOR_CUSTOMER_SUPPORT_POSITION = getStaffPositionById('seniorCustomerSupport');
export const SENIOR_DEVELOPER_POSITION = getStaffPositionById('seniorDeveloper');
export const SENIOR_TRANSLATION_POSITION = getStaffPositionById('seniorTranslation');
export const SENIOR_TUTOR_RECRUITMENT_POSITION = getStaffPositionById('seniorTutorRecruitment');
export const SENIOR_TUTOR_SUPPORT_POSITION = getStaffPositionById('seniorTutorSupport');
export const TESTER_POSITION = getStaffPositionById('tester');
export const TRANSLATION_POSITION = getStaffPositionById('translation');
export const TUTOR_PAYROLL_POSITION = getStaffPositionById('tutorPayroll');
export const TUTOR_RECRUITMENT_POSITION = getStaffPositionById('tutorRecruitment');
export const TUTOR_SUPPORT_POSITION = getStaffPositionById('tutorSupport');
/* eslint-enable max-len */
